import {
  createDomainListReduxUtil,
  PLANS_DEFAULT_TAG_FILTER
} from '@gymaholic/packages'

const PLANS_DOMAIN = 'plans'
const PLANS_ACTION = {
  LOAD_RECOMMENDED: 'PLANS_LOAD_RECOMMENDED',
  LOAD_SUGGESTED: 'PLANS_LOAD_SUGGESTED',
  LOAD_CREATOR_PLANS: 'PLANS_LOAD_CREATOR_PLANS',
  LOAD_CREATOR_PLAN: 'PLANS_LOAD_CREATOR_PLAN',
  LOAD_RECOMMENDED_BY_ID: 'PLANS_LOAD_RECOMMENDED_BY_ID',
  LOAD_RECOMMENDED_BY_ID_FROM_API: 'LOAD_RECOMMENDED_BY_ID_FROM_API',
  LOAD_BY_ID: 'LOAD_BY_ID',
  PURCHASE_PLAN: 'PURCHASE_PLAN',
  UPDATE_CURRENT: 'UPDATE_CURRENT',
  LOAD_STARTED_PLANS: 'LOAD_STARTED_PLANS',
  CREATE_PLAN: 'CREATE_PLAN',
  UPDATE_PLAN: 'UPDATE_PLAN'
}

const PLANS_ENDPOINT = {
  LOAD_RECOMMENDED: '/plans/recommended',
  LOAD_RECOMMENDED_BY_ID: '/plans/recommended/:id',
  LOAD_BY_ID: '/plans/:id',
  SUGGESTED: '/plans/suggested',
  STARTED: '/plans/started',
  LOAD_CREATOR_PLANS: '/creators/:creatorId/plans',
  LOAD_CREATOR_PLAN: '/creawtors/:creatorId/plans/:id',
  PURCHASE_PLAN: '/plans/:id/purchase',
  LOAD_PLANS: '/plans',
  PROFILES_WHO_STARTED: '/plans/:id/profiles-who-started'
}

const PLANS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  SUGGESTED: 'suggested',
  DATA: 'data',
  STARTED_PLANS: 'startedPlans',
  STARTED: 'started',
  TAG: 'tag',
  RECOMMENDED: 'recommended'
}

const PLANS_PATH = {
  ALL: `${PLANS_DOMAIN}.${PLANS_KEY.ALL}`,
  CURRENT: `${PLANS_DOMAIN}.${PLANS_KEY.CURRENT}`,
  STARTED: `${PLANS_DOMAIN}.${PLANS_KEY.STARTED}`,
  SUGGESTED: `${PLANS_DOMAIN}.${PLANS_KEY.SUGGESTED}`,
  TAG: `${PLANS_DOMAIN}.${PLANS_KEY.TAG}`,
  DATA: `${PLANS_DOMAIN}.${PLANS_KEY.DATA}`,
  STARTED_PLANS: `${PLANS_DOMAIN}.${PLANS_KEY.STARTED_PLANS}`,
  RECOMMENDED: `${PLANS_DOMAIN}.${PLANS_KEY.RECOMMENDED}`
}

const PLANS_STATE = {
  [PLANS_KEY.ALL]: createDomainListReduxUtil(),
  [PLANS_KEY.CURRENT]: null,
  [PLANS_KEY.SUGGESTED]: null,
  [PLANS_KEY.DATA]: {},
  [PLANS_KEY.STARTED_PLANS]: null,
  [PLANS_KEY.STARTED]: null,
  [PLANS_KEY.TAG]: PLANS_DEFAULT_TAG_FILTER,
  [PLANS_KEY.RECOMMENDED]: {
    ...createDomainListReduxUtil(),
    byTag: createDomainListReduxUtil(),
    byQuery: createDomainListReduxUtil()
  }
}

export {
  PLANS_ACTION,
  PLANS_ENDPOINT,
  PLANS_DOMAIN,
  PLANS_STATE,
  PLANS_KEY,
  PLANS_PATH
}
